import React from "react";
import AppRoutes from "./routes/Routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme.js"; // Importa o tema global



function App() {

  return (
    <ThemeProvider theme={theme}>
      {/* Reset de estilos globais */}
      <CssBaseline />

      {/* Conteúdo da aplicação */}
      <div className="App">
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          pauseOnFocusLoss
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
